import "../navbar/navbar.css";
import React from "react";
import _ from "lodash";
import logoUrl from "../../assets/logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { useHistory, useLocation } from "react-router-dom";
import {
  Button,
} from "reactstrap";
import httpService from "../../services/http.service";

let Navbar = (props) => {
  const history = useHistory();
  return (
    <div className="">
      <div className="row navbarmain">
        <div className="col-3 navbarlogo">
          <img className="imagelogo" src={logoUrl} alt="Logo"></img>
        </div>
        <div className="col-6 navbartext">
          Radiant Stream Director Customer Portal
        </div>
        <div className="col-3 headerLayoutlogout d-flex align-items-center justify-content-end ">
          <div className="d-flex align-items-center justify-content-end ">
            <div className="setting-ico setting-ico-w mr-2" onClick={() => { history.push("/uploadfile") }} />
            {/* <i class="fa-solid fa-gear"></i> */}
            <div className="userName px-2" style={{ color: "white", fontWeight: "bold" }}>
              <FontAwesomeIcon className="iconLayout" icon={faUser} />{" "}
              <u>{localStorage.getItem("customerId")}</u>
            </div>

            <div className="buttonLogout">
              <Button
                color="secondary"
                className=""
                onClick={async() => {
                  let res = await httpService.getByBoj('logout',{userId: localStorage.getItem("UserId")})
                  if(res && res.data.ack != 0){
                  localStorage.setItem("isSession", false);
                  localStorage.removeItem("customerId");
                  localStorage.removeItem("UserId");
                  localStorage.removeItem("CloudUserType");
                  localStorage.removeItem("token");
                  history.push("/login");
                  }
                  // props.setLogin('false')
                }}>
                Logout
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
